'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * The viewport a route was rendered for. `'mobile'` routes are only served to phones (the proxy picks them from
 * the user agent), so their layout is decided on the server and never responds back to wider widths; every other
 * route is `'responsive'`.
 */
export type ServerViewport = 'mobile' | 'responsive';

const ServerViewportContext = createContext<ServerViewport>('responsive');

export function ServerViewportProvider({ viewport, children }: { viewport: ServerViewport; children: ReactNode }) {
    return <ServerViewportContext.Provider value={viewport}>{children}</ServerViewportContext.Provider>;
}

export const useServerViewport = (): ServerViewport => useContext(ServerViewportContext);
